import React from 'react';
import Alert from '@amzn/awsui-components-core/alert';
import Box from '@amzn/awsui-components-core/box';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import type { QueryNotices } from 'src/components/star-grid/utils/queryNotices';

export interface ReportQueryNoticesProps {
  readonly notices: QueryNotices;
  readonly text: StarGridText;
}

export const ReportQueryNotices: React.FC<ReportQueryNoticesProps> = ({ notices, text }) => {
  const warnings = notices.warnings ?? [];
  if (notices.unresolvedMembers.length === 0 && notices.ignoredFilters.length === 0 && warnings.length === 0) return null;
  return (
    <SpaceBetween size="xs">
      {notices.unresolvedMembers.length > 0 && (
        <Alert type="info" header={text('reportUnresolvedMembersHeader')}>
          <Box>{text('reportUnresolvedMembersDescription')}</Box>
          <ul>
            {notices.unresolvedMembers.map((member) => (
              <li key={member}>{member}</li>
            ))}
          </ul>
        </Alert>
      )}
      {notices.ignoredFilters.length > 0 && (
        <Alert type="info" header={text('reportIgnoredFiltersHeader')}>
          <Box>{text('reportIgnoredFiltersDescription')}</Box>
          <ul>
            {notices.ignoredFilters.map((filter) => (
              <li key={filter.dimension}>
                <Box variant="strong" display="inline">
                  {filter.dimension}
                </Box>
                {filter.reason ? `: ${filter.reason}` : ''}
              </li>
            ))}
          </ul>
        </Alert>
      )}
      {warnings.length > 0 && (
        <Alert type="warning" header={text('reportQueryWarningsHeader')}>
          <ul>
            {warnings.map((warning) => (
              <li key={`${warning.code}|${warning.field ?? ''}`}>{warning.message}</li>
            ))}
          </ul>
        </Alert>
      )}
    </SpaceBetween>
  );
};
